import { render } from "./exhEdit.vue?vue&type=template&id=0561dd48&scoped=true"
import script from "./exhEdit.vue?vue&type=script&lang=js"
export * from "./exhEdit.vue?vue&type=script&lang=js"

import "./exhEdit.vue?vue&type=style&index=0&id=0561dd48&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0561dd48"],['__file',"src/views/exhibition/components/exhEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0561dd48"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0561dd48', __exports__)) {
    console.log('reload')
    api.reload('0561dd48', __exports__)
  }
  
  module.hot.accept("./exhEdit.vue?vue&type=template&id=0561dd48&scoped=true", () => {
    console.log('re-render')
    api.rerender('0561dd48', render)
  })

}


export default __exports__